module.exports = __webpack_public_path__ + "img/Home.effa0b51.svg";